<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="ch00_fm05"></a><a id="page_7"></a><img alt="Image" src="images/f0007-01.jpg"/></p>
<h2 class="h2"><strong>contents</strong></h2>
<p class="tocb"><a class="nounder" href="#/xhtml/ch00_fm06#ch00_fm06">Introduction</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch01#ch01">CHAPTER 1    15-Minute Eggs</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">CHAPTER 2    15-Minute Tortilla Tricks</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">CHAPTER 3    15-Minute Burgers</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">CHAPTER 4    15-Minute Poultry</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">CHAPTER 5    15-Minute Fish and Seafood</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">CHAPTER 6    15-Minute Steaks and Chops</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">CHAPTER 7    15-Minute Main Dish Salads</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">CHAPTER 8    15-Minute Skillet Suppers</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">CHAPTER 9    15-Minute Slow Cooker Meals</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">CHAPTER 10  15-Minute Side Dishes</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">CHAPTER 11  15-Minute Soups</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">CHAPTER 12  15-Minute Condiments, Sauces, Dressings, and Seasonings</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample">CHAPTER 13  15-Minute Beverages</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample">CHAPTER 14  15-Minute Snacks</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample">CHAPTER 15  15-Minute Desserts</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch16#ch16" title="Link target outside of Sample">CHAPTER 16  15-Minute Smoothies</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch17#ch17" title="Link target outside of Sample">CHAPTER 17  15-Minute “Cereal”</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch18_about#ch18_about" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch19_index#ch19_index" title="Link target outside of Sample">Index</span> <a id="page_8"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05.vue?88dbd612